import { useGraphQLQuery } from '@betterment/graphql';
import { HStack, Shimmer, Text, VStack } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { ErrorBoundary } from '@betterment/shared-components';

import { Disclosures } from './components/Disclosures';
import { NonAdvisedLinks } from './components/NonAdvisedLinks';

import { DisclosuresDocument } from '../../../RetailApp/graphql/query.disclosures.generated';

const footerCss = css.raw({
  paddingTop: 'space.400',
  maxWidth: '1224px',
  '& h3': {
    fontSize: 'fontSize.100',
    lineHeight: 'lineHeight.100',
    color: 'text',
    textDecoration: 'none',
    fontWeight: 'medium',
    paddingBottom: 'space.200',
    paddingTop: 'space.200',
  },
  '& h4': {
    textStyle: 'title100',
    color: 'text.weak',
  },
  '& a': {
    textDecoration: 'underline',
    fontSize: 'fontSize.50',
    lineHeight: 'lineHeight.30',
    color: 'text.weak',
  },
  '& span': {
    fontSize: 'fontSize.50',
    lineHeight: 'lineHeight.30',
    color: 'text.weak',
  },
  '& p': {
    fontSize: 'fontSize.50',
  },
});

const Footer: React.FC = () => {
  const { data } = useGraphQLQuery(DisclosuresDocument, { throwOnError: true });

  if (!data)
    return (
      <HStack css={{ gap: 'space.100', ...footerCss }}>
        <Shimmer css={{ height: '18px' }} />
        <Shimmer css={{ height: '18px' }} />
        <Shimmer css={{ height: '18px' }} />
        <Shimmer css={{ height: '18px' }} />
      </HStack>
    );

  const { advisor, disclosures } = data;
  const { comprehensiveDisclosure } = disclosures;

  return (
    <footer className={css(footerCss)}>
      {!advisor && <NonAdvisedLinks />}
      <VStack id="disclosures" css={{ paddingBottom: 'space.100', gap: 'space.100' }}>
        <Disclosures />
        <Text dangerouslySetInnerHTML={{ __html: comprehensiveDisclosure }} />
      </VStack>
    </footer>
  );
};

const FooterWithErrorBoundary: React.FC = () => {
  return (
    <ErrorBoundary fallbackType="inline">
      <Footer />
    </ErrorBoundary>
  );
};

export default FooterWithErrorBoundary;
